import React, { Component } from 'react';
import { ValidationService, UsersService } from 'shared/services';
import { PasswordInput, SuccessScreen } from 'shared/components';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import './ChangeKnownPassword.scss';

const successData = {
  copy: 'resetPassword.passwordResetCopy',
  buttonLabel: 'common.labels.backToProfile',
  link: '/profile',
};

class ChangeKnownPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      newPassword: '',
      submitted: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.renderForm = this.renderForm.bind(this);
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
      errorCurrent: [],
    });
  }

  renderForm() {
    return (
      <form name="newPassword" onSubmit={this.onSubmit} noValidate>
        <h4 className="mb-3">{this.props.t('resetPassword.changePasswordTitle')}</h4>
        <PasswordInput
          label="resetPassword.currentPasswordLabel"
          value={this.state.password}
          errors={this.state.errorCurrent}
          onChange={this.onChange}
          hideCriteria
        />
        <PasswordInput
          label="resetPassword.newPasswordLabel"
          name="newPassword"
          value={this.state.newPassword}
          errors={this.state.errorNew}
          onChange={this.onChange}
        />
        {this.state.errorValidation && (
          <p className="text-error text-small">{this.state.errorValidation}</p>
        )}
        <button type="submit" className="btn btn-primary w-100 m-0">
          {this.props.t('resetPassword.changePassword')}
        </button>
      </form>
    );
  }

  onSubmit(e) {
    e.preventDefault();
    const errors = [];
    const { password, newPassword } = this.state;

    if (!password || !newPassword) {
      errors.push('errors.passwordRequired');
      this.setState({
        errorCurrent: !password ? errors : [],
        errorNew: !newPassword ? errors : [],
      });
      return;
    }

    const isValidCurrent = ValidationService.validPassword(password);
    const isValidNew = ValidationService.validPassword(newPassword);

    if (!isValidCurrent || !isValidNew) {
      errors.push('errors.passwordInvalid');
      this.setState({
        errorCurrent: !isValidCurrent ? ['errors.passwordIncorrect'] : [],
        errorNew: !isValidNew ? errors : [],
      });
      return;
    }

    this.setState({
      errorCurrent: [],
      errorNew: [],
    });
    UsersService.changePassword({
      password,
      newPassword,
    })
      .then(() => {
        this.setState({
          errorCurrent: [],
          errorNew: [],
          submitted: true,
        });
      })
      .catch((error) => {
        this.setState({
          errorValidation: error.data.Error,
        });
      });
  }

  render() {
    return (
      <div className="change-password mx-auto w-390">
        {this.state.submitted ? <SuccessScreen data={successData} /> : this.renderForm()}
      </div>
    );
  }
}

ChangeKnownPassword.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ChangeKnownPassword);
